export function truncateValue(num, digits = 1) {
  const symbol = [
    {value: 1, symbol: ''},
    {value: 1E3, symbol: 'k'},
    {value: 1E6, symbol: 'M'},
    {value: 1E9, symbol: 'G'},
    {value: 1E12, symbol: 'T'},
    {value: 1E15, symbol: 'P'},
    {value: 1E18, symbol: 'E'},
  ];

  const regex = /\.0+$|(\.[0-9]*[1-9])0+$/;

  let i;
  for (i = symbol.length - 1; i > 0; i--) {
    if (num >= symbol[i].value) {
      break;
    }
  }

  return (num / symbol[i].value).toFixed(digits).replace(regex, '$1') + symbol[i].symbol;
}
